// 图像生成相关翻译

export const generation = {
    // 提示词和生成相关
    enterPrompt: 'Enter your prompt',
    promptPlaceholder: 'e.g., A beautiful sunset over mountains, oil painting style, warm colors, detailed landscape...',
    generationCount: 'Generation Count',
    images: 'images',
    credits: 'credits',
    tip: 'Tip: The more detailed your description, the closer the generated image will be to your imagination',
    generating: 'Generating...',
    startGeneration: 'Start Generation',
    generatedImage: 'Generated Image',
    generateSuccess: 'Generation successful',
    download: 'Download',
    downloadError: 'Download failed, please try again later',
    downloadImageError: 'Download failed, please try again later',
    
    // 错误处理
    unknownError: 'Unknown error occurred',
    contentPolicyError: 'Content policy violation detected',
    contentPolicySuggestion: 'Please modify your prompt to comply with content guidelines',
    rateLimitMessage: 'Rate limit exceeded',
    rateLimitSuggestion: 'Please wait a moment before trying again',
    creditsMessage: 'Insufficient credits',
    creditsSuggestion: 'Please purchase more credits to continue',
    generalSuggestion: 'Please try again later',
    enterPromptError: 'Please enter a prompt',
    generateImageError: 'Failed to generate image',
    rateLimitError: 'Rate limit exceeded, please try again later',
    insufficientCreditsError: 'Insufficient credits',
    networkError: 'Network error, please check your connection',
    
    // 灵感和标签
    inspiration: 'Inspiration',
    inspirationDescription: 'Get inspired by popular themes and styles',
    tags: {
      landscape: 'Landscape',
      portrait: 'Portrait',
      architecture: 'Architecture',
      art: 'Art',
      scifi: 'SciFi',
      nature: 'Nature',
      animals: 'Animals',
      creative: 'Creative'
    },
    
    // AI图像生成
    aiImageGeneration: 'AI Image Generation',
    style: 'Style',
    aspectRatio: 'Aspect Ratio',
    styles: {
      realistic: 'Realistic',
      artistic: 'Artistic',
      anime: 'Anime',
      cartoon: 'Cartoon',
      abstract: 'Abstract'
    },
    styleDescriptions: {
      realistic: 'Photorealistic images',
      artistic: 'Creative artistic style',
      anime: 'Japanese anime style',
      cartoon: 'Cartoon illustration style',
      abstract: 'Abstract conceptual art'
    },
    sizeDescriptions: {
      squareSmall: 'Square Small',
      squareLarge: 'Square Large (1:1)',
      landscape: 'Landscape',
      portrait: 'Portrait',
      portrait23: 'Portrait (2:3)',
      landscape32: 'Landscape (3:2)',
      portrait34: 'Portrait (3:4)',
      landscape43: 'Landscape (4:3)',
      portrait45: 'Portrait (4:5)',
      landscape54: 'Landscape (5:4)',
      portrait916: 'Portrait (9:16)',
      landscape169: 'Landscape (16:9)',
      ultrawide219: 'Ultra-wide (21:9)'
    },
    
    // 标签提示文本
    tagPrompts: {
      landscape: 'A majestic mountain range reflecting in a crystal clear alpine lake at sunset, with golden sun rays piercing through dramatic clouds, photorealistic.',
      portrait: 'A cinematic portrait of a young woman with freckles and windblown hair, natural lighting, bokeh background, shot on 35mm lens, highly detailed',
      architecture: 'A futuristic sustainable city skyline with vertical gardens and glass skyscrapers, warm sunlight, aerial view, architectural visualization',
      art: 'A surreal oil painting of a clock melting over a tree branch in a desert, in the style of Salvador Dali, dreamlike atmosphere, vivid colors',
      scifi: 'A cyberpunk street scene at night in a rainy neon-lit city, flying cars, holograms, wet pavement reflections, blade runner style',
      nature: 'A mystical ancient forest with glowing mushrooms and fireflies, mossy rocks, a small stream, magical atmosphere, fantasy art style',
      animals: 'A close-up macro shot of a colorful tree frog on a wet leaf, water droplets, sharp focus, vibrant green and orange colors',
      creative: 'A double exposure image combining a human silhouette with a starry night sky and forest landscape, ethereal and artistic'
    }
  };
